// Thin fetch wrapper for the builder endpoints. Never throws; callers branch
// on `ok` and `status` so a failed save can be surfaced rather than swallowed.

const csrfToken = () => document.querySelector("meta[name='csrf-token']")?.content

const request = async (url, body, method) => {
  try {
    const response = await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken(),
        Accept: "application/json"
      },
      body: JSON.stringify(body)
    })
    const payload = response.status === 204 ? {} : await response.json().catch(() => ({}))
    return { ok: response.ok, status: response.status, payload }
  } catch (error) {
    return { ok: false, status: 0, payload: { errors: [error.message] } }
  }
}

export default {
  saveDocument: (url, document, lockVersion, part = "page") =>
    request(url, { document, lock_version: lockVersion, part }, "PATCH"),
  createNode: (url, type) => request(url, { type }, "POST"),
  createSection: (url, key) => request(url, { key }, "POST"),
  cloneNode: (url, node) => request(url, { node }, "POST"),
  renderFragment: (url, document) => request(url, { document }, "POST")
}
